export const setOpenPaymentModal = () => ({
  type: "SET_PAYMENT_MODAL_OPEN",
});

export const setClosePaymentModal = () => ({
  type: "SET_PAYMENT_MODAL_CLOSE",
});
